<mat-toolbar>
  <div class="left-container">
    <img class="small-screen" (click)="onClick()" alt="SwissRe logo" src="./assets/images/SwissRe_Logo_Lake.svg" />
    <img class="small-screen" (click)="onClick()" alt="OneORM logo" src="./assets/images/OneORM_LOGO.svg" />
    <div class="appName">
      @if (environmentType | isNotEmpty) {
        <span>({{ environmentType }})</span>
        <app-commit-version />
      }
    </div>
  </div>
  <div class="spacer"></div>
  <div class="right-container">
    @if (drawerOpened$ | async | isFalse) {
      <button (click)="openDrawer()" color="primary" mat-flat-button><mat-icon color="primary"> concierge </mat-icon> Ask someone</button>
    }
    @if (drawerOpened$ | async) {
      <button (click)="closeDrawer()" color="primary" mat-stroked-button><mat-icon> concierge </mat-icon> Ask someone</button>
    }
    <app-manage-menu />
    <app-avatar [image]="userPhoto()" ariaLabel="Profile Picture" shape="circle" size="normal" styleClass="profileImg" />
  </div>
</mat-toolbar>
